module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_05-59f082d657090dfa0c3f8239cb33d93d.jpg";